/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

/** @example {"userID":"507f1f77bcf86cd799439011","hserviceID":"507f1f77bcf86cd799439011","hospitalID":"507f1f77bcf86cd799439011","content":"환자 메모 예시 내용","writerID":{"_id":"613aa681cb516152eed8fdb3","name":"홍친절","realName":"홍친절","type":"의사","jobType":"내과"},"writerType":1,"modifierID":{"_id":"613aa681cb516152eed8fdb3","name":"이친절","realName":"이친절","type":"간호사","jobType":"응급실"},"modifierType":1,"createdAt":"2024-01-01T00:00:00.000Z","updatedAt":"2024-01-02T00:00:00.000Z"} */
export interface V2ReservationUserNoteResponse {
  /** 사용자 ID */
  userID: string;
  /** 병원 서비스 ID */
  hserviceID: string;
  /** 병원 ID */
  hospitalID: string;
  /** 노트 내용 */
  content?: string;
  /** 작성자 ID */
  writerID: UserNameAndType;
  /** 작성자 유형 */
  writerType?: number;
  /** 수정자 ID */
  modifierID: UserNameAndType;
  /** 수정자 유형 */
  modifierType?: number;
  /**
   * 생성 날짜
   * @format date-time
   */
  createdAt: string;
  /**
   * 업데이트 날짜
   * @format date-time
   */
  updatedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface ApiV2ReservationusernoteElFindParams {
  /** 병원 ID */
  hospitalID: string;
  /** 병원서비스 ID */
  hserviceID: string;
  /** 유저 ID */
  userID: string;
}

export type ApiV2ReservationusernoteElFindData = ApiResponse & {
  data: V2ReservationUserNoteResponse[];
};

export type ApiV2ReservationusernoteElUpdateData = ApiResponse & {
  data: V2ReservationUserNoteResponse;
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-ReservationUserNote
     * @name ApiV2ReservationusernoteElFind
     * @summary 병원서비스별 치료 내역 (예약 유저 노트) 조회
     * @request GET:/v3/api/v2reservationusernote/el/find
     * @deprecated
     * @secure
     * @response `200` `ApiV2ReservationusernoteElFindData` 병원 서비스별 치료 내역 조회 성공
     */
    apiV2ReservationusernoteElFind: (query: ApiV2ReservationusernoteElFindParams, params: RequestParams = {}) =>
      this.request<ApiV2ReservationusernoteElFindData, any>({
        path: `/v3/api/v2reservationusernote/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description userID, hospiatlID, hserviceID 세가지를 기준으로 upsert 동작
     *
     * @tags V3-ReservationUserNote
     * @name ApiV2ReservationusernoteElUpdate
     * @summary 병원서비스별 치료 내역 (예약 유저 노트) 수정
     * @request POST:/v3/api/v2reservationusernote/el/update
     * @deprecated
     * @secure
     * @response `200` `ApiV2ReservationusernoteElUpdateData` 병원 서비스별 치료 내역 수정 성공
     */
    apiV2ReservationusernoteElUpdate: (
      data: {
        userID?: string;
        hospitalID?: string;
        hserviceID?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiV2ReservationusernoteElUpdateData, any>({
        path: `/v3/api/v2reservationusernote/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
